import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { usePassPolicies } from 'context/PassPolicy';
import { useSponsorContext } from 'context/Sponsor';
import { useUserContext } from 'context/user';
import { AppConfig } from 'utils/constants';
import { RouteNames } from '../routes/route-names';
import { Spinner } from '@nike/eds';
import style from './required-auth.module.css';
import { useAthleteContext } from 'context/athlete';

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const { isAthleteAuthenticated } = useAthleteContext();
  const location = useLocation();
  const { passPolicies, isInitialLoading } = usePassPolicies();
  const { sponsor } = useSponsorContext();
  const user = useUserContext();

  if (
    (!authState || !authState?.isAuthenticated) &&
    authState !== null &&
    !isAthleteAuthenticated()
  ) {
    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
    oktaAuth.setOriginalUri(originalUri);
    return <Navigate to="/login" />;
  }

  if (!user?.passplayUser || !sponsor || isInitialLoading) {
    return (
      <>
        <div className={style.dash__loader}>
          <Spinner size="large" id={style.dash__loader_spinner} />
          <h1 className={style.dash__loadertext}>Loading... </h1>
        </div>
      </>
    );
  }

  const currentRoute = location.pathname;
  const isETW = user.passplayUser.cponsorTypeId === 5 || sponsor.sponsorTypeId === 5;
  let hasAccess = false;
  switch (currentRoute) {
    case RouteNames.MYACCESS:
      hasAccess =
        !isETW ||
        (user?.passplayUser?.countryAlpha2?.toUpperCase() === 'KR' &&
          isETW &&
          passPolicies.some(
            policy =>
              policy.passTypeId === AppConfig.passType.employee ||
              policy.passTypeId === AppConfig.passType.swoosh,
          ));
      break;
    case RouteNames.FAMILY:
      hasAccess = passPolicies.some(policy => policy.passTypeId === AppConfig.passType.family);
      break;
    case RouteNames.APPROVALS:
      hasAccess = !!user.passplayUser.isApprover;
      break;
    case '/':
      hasAccess = true;
      break;
    default:
      hasAccess = false;
      break;
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
